/** Per-page <Suspense> fallback while a lazy route chunk loads. */
export function RouteFallback() {
  return (
    <div className="flex flex-1 items-center justify-center p-12 text-sm text-muted-foreground">
      <span className="animate-pulse">Loading…</span>
    </div>
  );
}
